import { BookingTypeEnum } from 'app/models';

export class BookingTypeModel {
    public static BookingTypeList: Array<any> = [
        { value: BookingTypeEnum.None, name: 'All' },
        { value: BookingTypeEnum.Regular, name: 'Regular' },
        //{ value: BookingTypeEnum.Fastest, name: 'Fastest' }, //TEAM1-656
        { value: BookingTypeEnum.ScanAndRide, name: 'Scan & Ride' },
		//{ value: BookingTypeEnum.Scheduled, name: 'Scheduled' } //TEAM1-656
	];

	public static BookingTypeBoracayList: Array<any> = [
		{ value: BookingTypeEnum.None, name: 'All' },
		{ value: BookingTypeEnum.Regular, name: 'Regular' },
		{ value: BookingTypeEnum.ScanAndRide, name: 'Scan & Ride' },
		{ value: BookingTypeEnum.DayTrip, name: 'Day Trip' }
	];
}
